import { Platform, Orientation } from "consts";
import { maxWidth } from "utils";

export const LogoSpace = {
  [maxWidth(1400)]: {
    [Orientation.LANDSCAPE]: 80,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 62,
  },
};

export const LogoWidth = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 100,
  },
};

export const LogoHeight = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 50,
  },
};

export const TextSpacing = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: 60,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 46,
  },
};

export const FontSize = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 16,
  },
};

export const ButtonMargin = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 52,
  },
};
